import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Select, MenuItem, Chip, Menu, Tooltip } from '@mui/material';

const getColorStyles = (value, theme) => {
    if (value === 1) {
        return {
            background: theme.palette.mode === 'dark'
                ? theme.palette.dark.main
                : theme.palette.success.light + 60,
            color: theme.palette.success.dark,
        };
    } else if (value === 0) {
        return {
            background: theme.palette.mode === 'dark'
                ? theme.palette.dark.main
                : theme.palette.error.light + 60,
            color: theme.palette.error.dark,
        };
    } else {
        return {
            background: 'white',
            color: 'black',
            borderColor: 'gray',
        };
    }
};

const ColoredDropdown = ({ itemArray, selectedValue, rowUuid, handleChange }) => {

    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const styles = getColorStyles(selectedValue, theme);

    const handleChipClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSelectChange = () => {
        handleChange(rowUuid);
        handleMenuClose();
    };

    const open = Boolean(anchorEl);
    const chipLabel = itemArray.find(item => item.value === selectedValue)?.name || "Select";

    return (
        <>
            <Tooltip placement='top' title='Change Status'>
                <Chip
                    label={chipLabel}
                    onClick={handleChipClick}
                    sx={{
                        background: styles.background,
                        color: styles.color,
                        cursor: 'pointer',
                    }}
                    size="medium"
                />
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    PaperProps={{
                        sx: {
                            border: 'none',
                            boxShadow: 'none',
                        }
                    }}
                >
                    <Select
                        value={selectedValue}
                        onChange={handleSelectChange}
                        sx={{ padding: '0px', margin: '0px' }}
                        size="small"
                    >
                        {itemArray.map((item, ind) => (
                            <MenuItem key={ind} value={item.value}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Menu>
            </Tooltip>
        </>
    );
};

export default ColoredDropdown;
